import type {
    VirtualAppointmentDto,
    VirtualAppointmentStatus
} from '../../../../services/virtualAppointments';

// Mirrors the backend: invalidating an RDI/SDI cancels its VAs in these statuses; done ones stay.
const CANCELED_ON_DELETE_STATUSES: ReadonlySet<VirtualAppointmentStatus> = new Set([
    'planned',
    'open',
    'waiting_patient',
    'waiting_doctor'
]);

const UNKNOWN_COUNT_NOTICE = 'Any planned or open VAs from this document will be canceled.';

export type DocumentDeleteVaState =
    { kind: 'loading' } | { kind: 'error' } | { kind: 'ready'; count: number };

export function countCanceledOnDelete(
    vas: readonly Pick<VirtualAppointmentDto, 'status'>[]
): number {
    return vas.filter((va) => CANCELED_ON_DELETE_STATUSES.has(va.status)).length;
}

// A failed read still warns, since the delete cancels the VAs either way.
export function documentDeleteVaNotice(state: DocumentDeleteVaState): string | null {
    if (state.kind === 'loading') return null;
    if (state.kind === 'error') return UNKNOWN_COUNT_NOTICE;
    if (state.count === 0) return null;
    const noun = state.count === 1 ? 'VA' : 'VAs';
    return `Its ${state.count} planned or open ${noun} will be canceled.`;
}
